module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRESS3UC3']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.detail.codempid) + " - " + _vm._s(_vm.detail.tab1.detail.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.detail.codpfinf) + " - " + _vm._s(_vm.detail.tab1.detail.desc_codpfinf) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "nummember",
      "name": "nummember"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.detail.nummember))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "dteeffec",
      "name": "dteeffec"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.detail.dteeffec)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "dtereti",
      "name": "dtereti"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.detail.dtereti)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.detail.flgemp),
      expression: "detail.tab1.detail.flgemp"
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab1.detail.flgemp, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab1.detail, "flgemp", "1")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['70']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.detail.flgemp),
      expression: "detail.tab1.detail.flgemp"
    }],
    attrs: {
      "type": "radio",
      "value": "2",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab1.detail.flgemp, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab1.detail, "flgemp", "2")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['80']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text txtarea-width width-70",
    attrs: {
      "id": "remark",
      "name": "remark"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.detail.remark))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.detail.ratereta),
      expression: "detail.tab1.detail.ratereta"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "ratereta",
      "name": "ratereta",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.detail.tab1.detail.ratereta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1.detail, "ratereta", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v("%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "dtechg",
      "name": "dtechg"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.detail.dtechg)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_c('u', [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['140']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS3UC3']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "dteplann",
      "name": "dteplann"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.detail.dteplann))])])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.tab1Table,
      "data": _vm.detail.tab1.table,
      "summaryLabel": _vm.labels['HRESS3UC3']['190']
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRESS3UC4']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive panel-detail-filter"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.tab2Table,
      "data": _vm.detail.tab2.table
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-730451fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hress3u/detail.vue
// module id = 3866
// module chunks = 1